export default __webpack_public_path__ + "static/paystack-f9fa176431cb020e9e83945544ff9063.png";